import service from '@/store/services/imr-release-service';

const state = {
  years: null,
  releaseId: null,
  loaded: false,
};

const mutations = {
  SET_IMR_RELEASE_YEARS: (state, payload) => {
    state.years = payload.years;
    state.releaseId = payload.release_id;
    state.loaded = true;
  },
};

const actions = {
  fetchImrReleaseYears({ commit }, params = {}) {
    return service
      .get(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
          return res.data;
        }
        commit('SET_IMR_RELEASE_YEARS', res.data);
        return res.data;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
};

const getters = {
  years: (state) => state.years,
  yearAt: (state) => (index) => (state.years ? state.years[index] : undefined),
  releaseId: (state) => state.releaseId,
  loaded: (state) => state.loaded,
};

const imrRelease = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default imrRelease;
